<template>
	<div class="">
		<div class="clearfloat">
			<div class="imgs flo_lf"><img @click="xin.goUrl('/personalCenter/head')" :src="user.avatar"/></div>
			<div class="message_box flo_lf">
				<div class="user_name"> {{user.nickname}}</div>
				<div>您的会员级别为：<span class="user_vip">{{user.type | isVip}}</span></div>
				<div>您回到同仁化学中国！您的上一次登录时间：{{user.last_time*1000 | timeFormat}}</div>
			</div>
		</div>
		<div class="tech_title">历史足迹</div>
		<div v-loading="loading">
			<div class="list_goods" v-if="dataList.length">
				<div class="goods_zi" v-for="(item) in dataList" :key="item.id" @click="xin.goUrl('/products/'+item.id)">
					<div class="images">
						<img :src="item.cover_img"/>
					</div>
					<div class="zi_title">{{item.title}}</div>
					<div class="lan">货号：{{item.model}}</div>
				</div>
			</div>
			<div v-else class="list_goods">
				<div class="kunasg">
					您还没有历史足迹呢~~
				</div>
			</div>
			<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
			:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
		</div>
	</div>
</template>

<script>
import {mapState,mapMutations,mapActions} from 'vuex'
	export default{
		data(){
			return {
				loading:true,
				total:0,//总数量
				pageNo:1,//当前页
				limit:0,//一页多少条
				dataList:[],
			}
		},
		computed:{
			...mapState(['user','token'])
		},
		created(){
			this.Postuserbrowse();
		},
		methods:{
			pageCurrentChange(val) {//分页查询
				this.pageNo = val;
				this.Postuserbrowse();
			},
			async Postuserbrowse(){
				this.loading = true;
				let {code,data} = await this.api.Postuserbrowse({page:this.pageNo});
				this.dataList = data.data||[];
				this.total = data.total;
				this.limit = data.per_page;
				this.loading = false;
			}
		}
	}
</script>

<style lang="scss" scoped="scoped">
.feye{
	margin: 40px auto 0;
	display: flex;
	justify-content: center;
}
	.list_goods{
		margin-top: 20px;
		display: flex;
		flex-wrap: wrap;
		// justify-content: space-around;
		.goods_zi{
			margin-left: 15px;
			margin-top: 30px;
			text-align: center;
			width: 244px;
			.images{
				width: 244px;
				height:183px;
				overflow: hidden;
				img {
					width: 100%;
					cursor: pointer;
					transition: all 0.6s;
					height: 100%;
					display: block;
					&:hover{
						transform: scale(1.2);
					}
				}
			}
			.zi_title{
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				text-decoration: underline;
			}
		}
	}
</style>
